import { render, staticRenderFns } from "./signSuccess.vue?vue&type=template&id=3ecbd0af&scoped=true"
import script from "./signSuccess.vue?vue&type=script&lang=js"
export * from "./signSuccess.vue?vue&type=script&lang=js"
import style0 from "./signSuccess.vue?vue&type=style&index=0&id=3ecbd0af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbd0af",
  null
  
)

export default component.exports